(function () {
  'use strict';

  const configuration = document.getElementById('miromi-judgeme-language');
  if (!configuration || configuration.dataset.initialized === 'true') return;
  let configurationValue;
  try {
    configurationValue = JSON.parse(configuration.textContent);
  } catch (_) {
    return;
  }
  if (!['de', 'fr', 'it'].includes(configurationValue.language)) return;
  const labels = configurationValue.labels;
  const keys = ['average_rating', 'stars', 'histogram', 'review_rating', 'page', 'verified_checkmark', 'authentic_medal', 'transparent_medal'];
  if (!labels || keys.some((key) => typeof labels[key] !== 'string' || !labels[key])) return;
  configuration.dataset.initialized = 'true';

  const rootSelector = '.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-all-reviews-page';
  const targetSelector = [
    '.jdgm-rev-widg__summary-stars[aria-label]',
    '.jdgm-prev-badge__stars[aria-label]',
    '.jdgm-all-reviews-rating[aria-label]',
    '.jdgm-histogram__star[aria-label]',
    '.jdgm-rev__rating[aria-label]',
    '.jdgm-paginate__page[aria-label]',
    '.jdgm-verified-checkmark[alt]',
    '.jdgm-medal[aria-label]',
    '.jdgm-medal img[alt]'
  ].join(', ');
  const observedRoots = new Map();
  let discoveryObserver;

  function format(key, values) {
    return labels[key].replace(/\[(rating|percentage|count|page)\]/g, (token, name) => values[name] ?? token);
  }

  function localize(element) {
    if (!element.matches(targetSelector) || !element.closest(rootSelector)) return;
    const attribute = element.hasAttribute('alt') && element.matches('.jdgm-verified-checkmark, .jdgm-medal img') ? 'alt' : 'aria-label';
    const original = element.getAttribute(attribute);
    let match;
    let translated;
    if (element.matches('.jdgm-rev-widg__summary-stars, .jdgm-all-reviews-rating') && (match = /^Average rating is (\d+(?:[.,]\d+)?) stars?$/.exec(original))) {
      translated = format('average_rating', { rating: match[1] });
    } else if (element.matches('.jdgm-prev-badge__stars, .jdgm-all-reviews-rating') && (match = /^(\d+(?:[.,]\d+)?) stars?$/.exec(original))) {
      translated = format('stars', { rating: match[1] });
    } else if (element.matches('.jdgm-histogram__star') && (match = /^(\d+(?:[.,]\d+)?)% \((\d+)\) reviews with ([1-5]) star rating$/.exec(original))) {
      translated = format('histogram', { percentage: match[1], count: match[2], rating: match[3] });
    } else if (element.matches('.jdgm-rev__rating') && (match = /^([1-5]) star review$/.exec(original))) {
      translated = format('review_rating', { rating: match[1] });
    } else if (element.matches('.jdgm-paginate__page') && (match = /^Page (\d+)$/.exec(original))) {
      translated = format('page', { page: match[1] });
    } else if (element.matches('.jdgm-verified-checkmark') && original === 'Verified Checkmark') {
      translated = labels.verified_checkmark;
    } else if (element.matches('.jdgm-medal, .jdgm-medal img') && original === 'Judge.me Diamond Authentic Shop medal') {
      translated = labels.authentic_medal;
    } else if (element.matches('.jdgm-medal, .jdgm-medal img') && original === 'Judge.me Diamond Transparent Shop medal') {
      translated = labels.transparent_medal;
    }
    if (translated && translated !== original) element.setAttribute(attribute, translated);
  }

  function localizeTree(node) {
    if (node.nodeType !== 1) return;
    localize(node);
    node.querySelectorAll(targetSelector).forEach(localize);
  }

  function observeRoot(root) {
    if (observedRoots.has(root) || !root.isConnected) return;
    if (root.parentElement?.closest(rootSelector)) return;
    localizeTree(root);
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') localize(record.target);
        else record.addedNodes.forEach(localizeTree);
      });
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'alt'] });
    observedRoots.set(root, observer);
  }

  function discover(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(rootSelector)) observeRoot(node);
    node.querySelectorAll(rootSelector).forEach(observeRoot);
  }

  function stop() {
    discoveryObserver?.disconnect();
    observedRoots.forEach((observer) => observer.disconnect());
    observedRoots.clear();
  }

  function start() {
    stop();
    document.querySelectorAll(rootSelector).forEach(observeRoot);
    if (!document.body) return;
    discoveryObserver = new MutationObserver((records) => {
      let removed = false;
      records.forEach((record) => {
        if (record.removedNodes.length) removed = true;
        if (record.target.nodeType === 1 && record.target.closest(rootSelector)) return;
        record.addedNodes.forEach(discover);
      });
      if (removed) observedRoots.forEach((observer, root) => {
        if (!root.isConnected) {
          observer.disconnect();
          observedRoots.delete(root);
        }
      });
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', (event) => { if (event.persisted) start(); });
})();
